import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { removeBlock, chnageHeroBlockContent, changeWrapperBlockContent } from './grapesjsUtils';

// Import required editor CSS
import 'grapesjs/dist/css/grapes.min.css';

// const defaultNewsletterMjmlOld = `
// <mjml>
//   <mj-body background-color="#ffffff">
//     <mj-section>
//       <mj-column>
//         <mj-text font-size="22px" align="center"><strong>Sharevino</strong> — Hello WineLovers!</mj-text>
//         <mj-text align="center">This email uses a tracked CTA for CPA measurement.</mj-text>
//         <mj-button href="" align="center">View Wines</mj-button>
//       </mj-column>
//     </mj-section>
//     <mj-section id="sv-unsub" data-locked="1">
//       <mj-column>
//         <mj-text align="center" font-size="12px" color="#666666">
//           You’re receiving this because you opted in to ShareVino updates.
//           <a href="https://sharevino.co/account-settings">Unsubscribe</a>
//           •
//           <a href="https://sharevino.co/account-settings">Manage preferences</a>
//         </mj-text>
//       </mj-column>
//     </mj-section>
//   </mj-body>
// </mjml>`;

// const defaultNewsletterMjmlOld2 = `
// <mjml>
//    <mj-body background-color="#ffffff">
//       <mj-section>
//          <mj-column padding-top="10px">
//             <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764231966846.jpg" padding-top="0px" padding-bottom="0px" padding-left="0px" padding-right="20px"></mj-image>
//          </mj-column>
//          <mj-column>
//             <mj-text padding-left="0px" padding-right="0px"><b id="i13vx" draggable="true" style="font-size:34px;line-height:58px;">The Best-Selling<br id="iwucx" draggable="true"/>New Novel from<br id="ib7vk" draggable="true"/>Joe Shaw</b></mj-text>
//             <mj-text color="#737373" font-size="18px" container-background-color="#ffffff" padding-left="0px" padding-right="0px" line-height="28px">Young Blood tells a tale of a girl that<span style="padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;"></span><br/>gets lost in temptations, peer<br/>pressure and bad influences. Now,<br/>she's trying to break free to find her<br/>true self.</mj-text>
//             <mj-text padding-left="0px" padding-right="0px"><b style="font-size:18.5px;color:#737373;">$9.99          </b><strike id="i1u1k" draggable="true" class="gjs-hovered" style="color:rgb(115, 115, 115);font-size:18.5px;">$12.99</strike></mj-text>
//             <mj-button background-color="#ffffff" color="#000000" border="3px solid #000000" padding-right="0px" padding-left="0px" width="100%"><span style="font-size:18.5px;">SHOP NOW</span></mj-button>
//          </mj-column>
//       </mj-section>
//       <mj-section>
//          <mj-column>
//             <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764234069583.jpg"></mj-image>
//          </mj-column>
//          <mj-column>
//             <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764234233591.jpg"></mj-image>
//          </mj-column>
//          <mj-column>
//             <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764234240332.jpg"></mj-image>
//          </mj-column>
//       </mj-section>
//       <mj-section>
//          <mj-column border="1.5px solid #a42938" border-radius="10px 10px 10px 10px">
//             <mj-text font-size="34px"><b>The Tale of a Good Girl Gone Bad</b></mj-text>
//             <mj-text font-size="18px" color="#737373" line-height="28px">Joy grew up as a bright kid in a city that o!ered no perspectives.<br/>Despite the circumstances, her dad taught her about physics, maths<br/>and cultures. He was dedicated to o!ering his little girl a better<br/>future. Until one cold November morning Joy finds out that her dad<br/>abruptly fled the country.</mj-text>
//             <mj-button background-color="#ffffff" color="#000000" border="3px solid #000000" align="left"><span style="font-size:18.5px;">READ THE FULL NOVEL</span></mj-button>
//          </mj-column>
//       </mj-section>
//       <mj-section>
//          <mj-column padding-right="0px" padding-left="0px" padding-bottom="0px" padding-top="10px">
//             <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764240200675.jpg" padding-top="0px" padding-bottom="0px" padding-left="0px" padding-right="20px"></mj-image>
//          </mj-column>
//          <mj-column>
//             <mj-text padding-top="0px" padding-bottom="0px" padding-left="0px" padding-right="0px"><b id="ijxql-2" draggable="true" style="color:#ff8585;font-size:18px;">About the author</b></mj-text>
//             <mj-text padding-right="0px" padding-left="0px" color="#000000" padding-top="0px" padding-bottom="0px"><b style="font-size:34px;line-height:58px;">Joe Shaw</b></mj-text>
//             <mj-text color="#737373" line-height="28px" padding-left="0px" font-size="18px" padding-right="0px">After releasing her first fictional<br/>thriller "As Long as We're Together."<br/>The British writer challenges the<br/>reader to ask questions about their<br/>own life and touches upon topics of<br/>modern-day mental health and<br/>relationships.</mj-text>
//             <mj-button background-color="#ffffff" color="#000000" border="3px solid #000000" align="left" width="100%" padding-right="0px" padding-left="0px"><span style="font-size:18px;">READ MORE</span></mj-button>
//          </mj-column>
//       </mj-section>
//       <mj-section>
//          <mj-column>
//             <mj-text font-size="34px" padding-top="0px" padding-bottom="0px" padding-left="0px" padding-right="0px"><b>More books from this author</b></mj-text>
//          </mj-column>
//       </mj-section>
//       <mj-section>
//          <mj-column padding-top="10px" padding-bottom="0px" padding-left="0px" padding-right="0px">
//             <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764231966846.jpg" padding-top="0px" padding-bottom="0px" padding-left="0px" padding-right="15px"></mj-image>
//             <mj-text font-size="34px" padding-left="0px" padding-right="0px"><b>Young Blood</b></mj-text>
//             <mj-text color="#737373" line-height="28px" font-size="18px" padding-left="0px" padding-right="15px">Young Blood tells a tale of a girl that gets lost in temptations, peer<br/>pressure and bad influences. Now,<br/>she's trying to break free to find her<br/>true self.</mj-text>
//             <mj-text padding-left="0px" padding-right="15px"><b style="font-size:18.5px;color:#737373;">$9.99          </b><strike id="i1u1k-2" draggable="true" class="gjs-hovered" style="color:rgb(115, 115, 115);font-size:18.5px;">$12.99</strike></mj-text>
//             <mj-button background-color="#ffffff" color="#000000" border="3px solid #000000" width="100%" padding-left="0px" padding-right="15px"><span style="font-size:18px;">SHOP NOW</span></mj-button>
//          </mj-column>
//          <mj-column padding-top="10px" padding-right="0px" padding-left="0px" padding-bottom="0px">
//             <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764231966846.jpg" padding-top="0px" padding-bottom="0px" padding-left="15px" padding-right="0px"></mj-image>
//             <mj-text font-size="34px" padding-left="15px"><font color="#000000"><b>Young blood</b></font></mj-text>
//             <mj-text color="#737373" line-height="28px" padding-left="15px" font-size="18px" padding-right="0px">Young Blood tells a tale of a girl that gets lost in temptations, peer<br/>pressure and bad influences. Now,<br/>she's trying to break free to find her<br/>true self.</mj-text>
//             <mj-text padding-right="0px" padding-left="15px"><b style="font-size:18.5px;color:#737373;">$9.99          </b><strike id="i1u1k-2-2" draggable="true" class="gjs-hovered" style="color:rgb(115, 115, 115);font-size:18.5px;">$12.99</strike></mj-text>
//             <mj-button background-color="#ffffff" color="#000000" border="3px solid #000000" width="100%" padding-right="0px" padding-left="15px"><span style="font-size:18px;">SHOP NOW</span></mj-button>
//          </mj-column>
//       </mj-section>
//       <mj-section>
//          <mj-column>
//             <mj-text padding-left="0px" padding-right="0px"><span id="icj85-2" draggable="true" style="color:rgb(255, 133, 133);font-size:19px;"><b style="font-size:18px;">What other readers have said</b></span></mj-text>
//             <mj-text padding-left="0px" padding-right="0px"><b id="i7yhqu-2" draggable="true" style="font-size:34px;">Latest Book Reviews</b></mj-text>
//          </mj-column>
//       </mj-section>
//       <mj-section>
//          <mj-column padding-top="10px" padding-bottom="0px" padding-left="0px" padding-right="10px">
//             <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764243870769.jpg" padding-left="0px"></mj-image>
//             <mj-text color="#737373" line-height="28px" font-size="18px" padding-left="0px" padding-right="0px"><span style="width:300px;"></span>“Excellent! It's a great reflection of how peer pressure forces youth to<br/>commit crimes. A must-read for<br/>troubled teenagers that try to better<br/>their lives.”</mj-text>
//             <mj-text font-size="18px" text-decoration="underline" color="#a52834" padding-left="0px">Ben Wilson, MailerLite</mj-text>
//          </mj-column>
//          <mj-column padding-top="10px" padding-bottom="0px" padding-left="10px" padding-right="0px">
//             <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764243870769.jpg" padding-left="0px"></mj-image>
//             <mj-text color="#737373" line-height="28px" padding-left="0px" font-size="18px" padding-right="0px"><span style="width:300px;"></span>“Loved this! Not only is the story very interesting and giving you new<br/>insights, but it's also written in a way<br/>that you can't stop turning the<br/>pages!”</mj-text>
//             <mj-text font-size="18px" text-decoration="underline" color="#a52834" padding-left="0px">Ben Wilson, MailerLite</mj-text>
//          </mj-column>
//       </mj-section>
//       <mj-section>
//          <mj-column>
//             <mj-social border-radius="12px" mode="horizontal" padding-left="0px" align="left" icon-size="24px">
//                <mj-social-element name="custom" src="https://cdn-icons-png.flaticon.com/512/3536/3536423.png" border-radius="0px 0 0 0"></mj-social-element>
//                <mj-social-element name="custom" src="https://abs.twimg.com/favicons/twitter.3.ico" border-radius="0 0 0px 0"></mj-social-element>
//                <mj-social-element name="custom" src="https://cdn-icons-png.flaticon.com/512/1400/1400829.png" border-radius="0px 0 0 0"></mj-social-element>
//             </mj-social>
//          </mj-column>
//       </mj-section>
//       <mj-section data-locked="1">
//          <mj-column>
//             <mj-text align="center" color="#666666" font-size="12px">
//                You’re receiving this because you opted in to ShareVino updates.
//                <a href="https://sharevino.co/account-settings">Unsubscribe</a>
//                •
//                <a href="https://sharevino.co/account-settings">Manage preferences</a>
//             </mj-text>
//          </mj-column>
//       </mj-section>
//    </mj-body>
// </mjml>
// `;

// const defaultNewsletterMjml2 =
// `
// <mjml>
//    <mj-body background-color="#ffffff">
//       <mj-section>
//          <mj-column>
//             <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764318629248.jpg" width="150px" height="75px"></mj-image>
//          </mj-column>
//       </mj-section>
//       <mj-section>
//          <mj-column>
//             <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764318748964.jpg"></mj-image>
//          </mj-column>
//       </mj-section>
//       <mj-section>
//          <mj-column>
//             <mj-text font-size="18px" font-weight="700">Your dream spot, wherever<br/>in the world, for the right<br/>price.</mj-text>
//          </mj-column>
//          <mj-column>
//             <mj-text font-size="18px" color="#6e6e6e">Tell us your wishes and budget<br/>and we'll find you the house of<br/>your dreams!</mj-text>
//          </mj-column>
//       </mj-section>
//       <mj-section>
//          <mj-column>
//             <mj-divider width="60%"></mj-divider>
//          </mj-column>
//       </mj-section>
//       <mj-section>
//          <mj-column>
//             <mj-text font-size="34px" font-weight="700">New on the market</mj-text>
//          </mj-column>
//       </mj-section>
//       <mj-section>
//          <mj-column>
//             <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764326122584.jpg"></mj-image>
//             <mj-text font-size="34px" font-weight="700">01</mj-text>
//             <mj-text padding-right="0px" font-size="18px" font-weight="600">MODERN DESIGN</mj-text>
//             <mj-text font-size="18px" align="center" font-weight="600">LOOK INSIDE</mj-text>
//          </mj-column>
//          <mj-column>
//             <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764326136733.jpg"></mj-image>
//             <mj-text font-size="34px" font-weight="700">02</mj-text>
//             <mj-text padding-right="0px" font-size="18px" font-weight="600">CITY LIFE</mj-text>
//             <mj-text font-size="18px" align="center" font-weight="600">LOOK INSIDE</mj-text>
//          </mj-column>
//          <mj-column>
//             <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764326144543.jpg"></mj-image>
//             <mj-text font-size="34px" font-weight="700">03</mj-text>
//             <mj-text padding-right="0px" font-size="18px" font-weight="600">LUXURY LIVING</mj-text>
//             <mj-text font-size="18px" align="center" font-weight="600">LOOK INSIDE</mj-text>
//          </mj-column>
//       </mj-section>
//       <mj-section>
//          <mj-column>
//             <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764326374395.jpg"></mj-image>
//             <mj-text font-size="34px" font-weight="700">04</mj-text>
//             <mj-text padding-right="0px" font-size="18px" font-weight="600">VINTAGE HOMES</mj-text>
//             <mj-text font-size="18px" align="center" font-weight="600">LOOK INSIDE</mj-text>
//          </mj-column>
//          <mj-column>
//             <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764326379792.jpg"></mj-image>
//             <mj-text font-size="34px" font-weight="700">05</mj-text>
//             <mj-text padding-right="0px" font-size="18px" font-weight="600">SEASIDE GETAWAY</mj-text>
//             <mj-text font-size="18px" align="center" font-weight="600">LOOK INSIDE</mj-text>
//          </mj-column>
//          <mj-column>
//             <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764326384893.jpg"></mj-image>
//             <mj-text font-size="34px" font-weight="700">06</mj-text>
//             <mj-text padding-right="0px" font-size="18px" font-weight="600">INTO THE WILD</mj-text>
//             <mj-text font-size="18px" align="center" font-weight="600">LOOK INSIDE</mj-text>
//          </mj-column>
//       </mj-section>
//       <mj-section>
//          <mj-column>
//             <mj-text font-size="39px" align="center" color="#acacac" font-weight="700" line-height="45px">"Quality of life actually<br/>begins at home - it's in your<br/>street, around your<br/>community."</mj-text>
//          </mj-column>
//       </mj-section>
//       <mj-section>
//          <mj-column>
//             <mj-text font-size="28px" font-weight="700">Explore your new<br/>neighborhood</mj-text>
//             <mj-text font-size="18px" color="#6e6e6e" line-height="25px">Pick your dream location and<br/>discover what properties are<br/>waiting to be taken o" the<br/>market.</mj-text>
//          </mj-column>
//          <mj-column>
//             <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764326722391.jpg"></mj-image>
//          </mj-column>
//       </mj-section>
//       <mj-section>
//          <mj-column>
//             <mj-divider width="60%"></mj-divider>
//          </mj-column>
//       </mj-section>
//       <mj-section>
//          <mj-column>
//             <mj-text font-size="28px" align="center" font-weight="700">Any questions?</mj-text>
//             <mj-button background-color="#ffffff" font-size="17px" color="#000000" border="3px solid black" border-radius="0px 0 0 0">JUST ASK US</mj-button>
//          </mj-column>
//       </mj-section>
//       <mj-section data-locked="1">
//          <mj-column>
//             <mj-text align="center" font-size="12px" color="#666666">
//                You’re receiving this because you opted in to ShareVino updates.
//                <a href="https://sharevino.co/account-settings">Unsubscribe</a>
//                •
//                <a href="https://sharevino.co/account-settings">Manage preferences</a>
//             </mj-text>
//          </mj-column>
//       </mj-section>
//    </mj-body>
// </mjml>
// `

// const defaultNewsletterMjml3 =
// `
// <mjml>
//    <mj-body background-color="#ffffff">
//       <mj-section>
//          <mj-column>
//             <mj-text font-size="18px" align="center" color="#ac9e9e">P.S. Anniversary sale lasts till the end of this month. Hurry up!</mj-text>
//             <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764327278325.jpg" align="left" width="150px" height="75px"></mj-image>
//          </mj-column>
//       </mj-section>
//       <mj-section>
//          <mj-column>
//             <mj-divider border-width="2px" border-style="dashed"></mj-divider>
//          </mj-column>
//       </mj-section>
//       <mj-section>
//          <mj-column>
//             <mj-text font-size="56px" font-weight="400" font-family="Times New Roman, Times, serif" color="#3a5c50">Anniversary celebration<br/>sale is here!</mj-text>
//          </mj-column>
//       </mj-section>
//       <mj-section>
//          <mj-column padding-bottom="0px" padding-top="0px" padding-right="0px" padding-left="0px">
//             <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764327588101.jpg" padding-top="0px" padding-bottom="0px" padding-right="0px" padding-left="0px"></mj-image>
//             <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764327630544.jpg" padding-top="0px" padding-bottom="0px" padding-right="0px" padding-left="0px"></mj-image>
//          </mj-column>
//          <mj-column padding-top="0px" padding-right="0px" padding-left="0px" padding-bottom="0px">
//             <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764327602262.jpg" padding-top="0px" padding-bottom="0px" padding-right="0px" padding-left="0px"></mj-image>
//             <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764327641828.jpg" padding-top="0px" padding-bottom="0px" padding-right="0px" padding-left="0px"></mj-image>
//          </mj-column>
//       </mj-section>
//       <mj-section>
//          <mj-column>
//             <mj-text padding-right="0px" padding-left="0px" font-size="28px" color="#3a5c50" font-family="Times New Roman, Times, serif" font-weight="700">Hey there, Plant pals!</mj-text>
//             <mj-text padding-right="0px" padding-left="0px" font-size="18px" line-height="25px">Hold onto your gardening gloves because something exciting is sprouting<br/>at Verde &amp; Gardens – it’s our Anniversary Celebration Sale! Can you<br/>believe it?</mj-text>
//             <mj-text padding-right="0px" padding-left="0px" font-size="18px" line-height="25px">We've got a bloomin' fantastic o"er just for you. Get <b>25% OFF</b> on<br/>everything plant-related in our store. Yep, you heard it right! From those<br/>adorable succulents that make you smile to po#ery pieces that'll give<br/>your plants the fanciest homes on the block.</mj-text>
//          </mj-column>
//       </mj-section>
//       <mj-section>
//          <mj-column>
//             <mj-button background-color="#ffffff" font-size="18px" color="#3a5c50" border="3px solid black" width="100%">SHOP PLANTS</mj-button>
//          </mj-column>
//          <mj-column>
//             <mj-button font-size="18px" color="#3a5c50" border="3px solid #000000" container-background-color="#ffffff" background-color="#ffffff" width="100%">SHOP PLANTS</mj-button>
//          </mj-column>
//       </mj-section>
//       <mj-section>
//          <mj-column>
//             <mj-divider border-width="2px" border-style="dashed"></mj-divider>
//          </mj-column>
//       </mj-section>
//       <mj-section>
//          <mj-column>
//             <mj-text font-size="56px" font-weight="400" font-family="Times New Roman, Times, serif" color="#3a5c50">See what else we got...</mj-text>
//          </mj-column>
//       </mj-section>
//       <mj-section>
//          <mj-column>
//             <mj-text font-size="17px" color="#3a5c50" text-decoration="underline" font-weight="700">BOOK A WORKSHOP</mj-text>
//             <mj-divider border-color="#3a5c50"></mj-divider>
//             <mj-text font-size="17px" color="#3a5c50" text-decoration="underline" font-weight="700">PLANT TIPS</mj-text>
//             <mj-divider border-color="#3a5c50"></mj-divider>
//             <mj-text font-size="17px" color="#3a5c50" text-decoration="underline" font-weight="700">SHOP PLANTS</mj-text>
//             <mj-divider border-color="#3a5c50"></mj-divider>
//             <mj-text font-size="17px" color="#3a5c50" text-decoration="underline" font-weight="700">STORE LOCATIONS</mj-text>
//          </mj-column>
//       </mj-section>
//       <mj-section>
//          <mj-column>
//             <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764328523912.jpg"></mj-image>
//             <mj-text font-size="18px" line-height="25px">Let’s make our spaces greener, our homes cozier, and our lives richer with the simple joy of plants.<br/><br/>Thank you for being part of this thriving garden of friendship and foliage.<br/>Here’s to another year of nurturing dreams and nurturing plants – because at Verde &amp; Gardens, we believe in the magic that grows from the soil and blossoms in our hearts.<br/><br/>Founder,<br/><b>Emily Davis</b></mj-text>
//             <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764328650200.jpg" align="left" width="150px" height="75px"></mj-image>
//          </mj-column>
//       </mj-section>
//       <mj-section>
//          <mj-column>
//             <mj-divider border-width="2px" border-style="dashed"></mj-divider>
//          </mj-column>
//       </mj-section>
//       <mj-section>
//          <mj-column>
//             <mj-social font-size="12px" icon-size="24px" border-radius="12px" mode="horizontal" align="left">
//                <mj-social-element name="custom" src="https://cdn-icons-png.flaticon.com/512/3536/3536423.png" border-radius="0px 0 0 0"></mj-social-element>
//                <mj-social-element name="custom" src="https://abs.twimg.com/favicons/twitter.3.ico" border-radius="0px 0 0 0"></mj-social-element>
//                <mj-social-element name="custom" src="https://cdn-icons-png.flaticon.com/512/1400/1400829.png" border-radius="0px 0 0 0"></mj-social-element>
//             </mj-social>
//          </mj-column>
//       </mj-section>
//       <mj-section data-locked="1">
//          <mj-column>
//             <mj-text align="center" font-size="12px" color="#666666">
//                You’re receiving this because you opted in to ShareVino updates.
//                <a href="https://sharevino.co/account-settings">Unsubscribe</a>
//                •
//                <a href="https://sharevino.co/account-settings">Manage preferences</a>
//             </mj-text>
//          </mj-column>
//       </mj-section>
//    </mj-body>
// </mjml>
// `

const defaultNewsletterMjml = `
<mjml>
   <mj-body background-color="#ffffff">
      <mj-section padding-bottom="4px">
         <mj-column>
            <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764470143254.jpg" width="99px"></mj-image>
            <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764478865257.png" padding-top="0px" padding-bottom="0px" padding-right="0px" padding-left="0px"></mj-image>
         </mj-column>
      </mj-section>
      <mj-section>
         <mj-column border="1.5px solid #a42938" border-radius="10px 10px 10px 10px" padding-bottom="30px">
            <mj-text font-size="19px" padding-right="20px" padding-bottom="0px">
               <p class="p1"><span class="s1"></span></p>
               <h1><b>Wine Event Highlights</b></h1>
               <p></p>
               <p></p>
            </mj-text>
            <mj-text font-size="18px" color="#786e6e" line-height="28px" font-family="Arial, Helvetica, sans-serif">Discover <b>120+ wines</b> from top producers, alongside key highlights, moments, and stories. Browse the bottles we poured, revisit your favorites, leave tasting notes and Tasteimonials, and <b style="caret-color:rgb(0, 0, 0);color:#737373;font-size:18px;font-weight:400;">dive deeper into each one through ShareVino</b>. <br/></mj-text>
            <span style="color:#737373;font-family:Arial, Helvetica, sans-serif;font-size:18px;"><br/></span>
            <mj-button background-color="#ffffff" color="#000000" border="3px solid #000000" align="left" href="https://sharevino.co/partners/sharevino"><span style="font-size:18.5px;">VIEW ALL WINES</span></mj-button>
         </mj-column>
      </mj-section>
      <mj-section>
         <mj-column padding-top="10px">
            <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764476210168.png" padding-top="0px" padding-bottom="0px" padding-left="0px" padding-right="20px"></mj-image>
         </mj-column>
         <mj-column>
            <mj-text padding-left="0px" padding-right="0px" padding-bottom="0px" font-weight="400">
               <b id="i13vx" draggable="true" style="font-size:34px;line-height:40px;">Featured Wine of the Event</b>
               <p></p>
            </mj-text>
            <mj-text padding-right="19px" padding-left="0px" font-size="17px" color="#af0e18" font-weight="500">98/100 points</mj-text>
            <mj-text color="#737373" font-size="18px" container-background-color="#ffffff" padding-left="0px" padding-right="0px" line-height="28px"><b style="color:#737373;font-family:Arial, Helvetica, sans-serif;font-size:18px;font-weight:400;">Explore one of the standout wines featured during our tasting experience, happening this weekend.</b></mj-text>
            <mj-text padding-left="0px" padding-right="0px"><b style="font-size:18.5px;color:#737373;">$124.99          </b><strike id="i1u1k" draggable="true" class="gjs-hovered" style="color:rgb(115, 115, 115);font-size:18.5px;">$132.99</strike></mj-text>
            <mj-button background-color="#ffffff" color="#000000" border="3px solid #000000" padding-right="0px" padding-left="0px" width="100%" href="https://sharevino.co/partners/sharevino/wines/caymus-2"><span style="font-size:18.5px;color:#000000;">DISCOVER NOW</span></mj-button>
         </mj-column>
      </mj-section>
      <mj-section>
         <mj-column border="1.5px solid #a42938" border-radius="10px 10px 10px 10px" padding-bottom="30px">
            <mj-text font-size="19px" padding-right="20px" padding-bottom="0px">
               <p class="p1"><span class="s1"></span></p>
               <h1>Behind the Wines</h1>
               <p></p>
            </mj-text>
            <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764526357160.png"></mj-image>
            <mj-text font-size="18px" color="#737373" line-height="28px" font-family="Arial, Helvetica, sans-serif"><span style="color:#737373;font-family:Arial, Helvetica, sans-serif;font-size:18px;">Discover their story, winemaking philosophy, and the passion that shapes each bottle. Learn how their craft and heritage influence the wines you enjoyed during our tasting experience.</span><br/></mj-text>
            <mj-button background-color="#ffffff" color="#000000" border="3px solid #000000" align="left" href="https://sharevino.co/partners/sharevino"><span style="font-size:18.5px;">MEET THE PRODUCERS</span></mj-button>
         </mj-column>
      </mj-section>
      <mj-section padding-bottom="0px">
         <mj-column>
            <mj-text font-size="34px" padding-top="0px" padding-bottom="0px" padding-left="0px" padding-right="0px" align="center">
               <b style="align:center;">More Wines to Explore</b>
               <p></p>
            </mj-text>
         </mj-column>
      </mj-section>
      <mj-section>
         <mj-column padding-top="10px" padding-bottom="0px" padding-left="0px" padding-right="0px">
            <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764476210216.png" padding-top="0px" padding-bottom="8px" padding-left="0px" padding-right="15px" width="200px" border-radius="0px 0px 0px 0px"></mj-image>
            <mj-text font-size="28px" padding-left="0px" padding-right="0px" align="center"><b style="align:center;">Elegant &amp; Fruity</b></mj-text>
            <mj-text color="#737373" line-height="28px" font-size="18px" padding-left="0px" padding-right="15px" font-family="Arial, Helvetica, sans-serif" padding-bottom="0px">
               <p class="p1">Elegant structure, balanced, and beautifully expressive, showing layers of vibrant fruit and refined craftsmanship from start to finish.</p>
            </mj-text>
            <span style="color:#737373;font-size:18px;"><br/></span>
            <mj-text padding-right="0px" padding-left="15px" align="center" padding-top="0px"><b style="font-size:18.5px;color:#737373;">$99.99          </b><strike id="i1u1k-2-2-2" draggable="true" class="gjs-hovered" style="color:rgb(115, 115, 115);font-size:18.5px;">$122.99</strike></mj-text>
            <mj-button background-color="#ffffff" color="#000000" border="3px solid #000000" width="100%" padding-right="15px" padding-left="15px" href="https://sharevino.co/partners/sharevino/wines/the-prisoner-red-blend-2" padding-top="15px"><span style="font-size:18px;">DISCOVER NOW</span></mj-button>
         </mj-column>
         <mj-column padding-top="10px" padding-bottom="0px" padding-left="0px" padding-right="0px">
            <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764528440630.jpg" padding-top="0px" padding-bottom="8px" padding-left="0px" padding-right="15px" width="200px" border="0px solid #000000"></mj-image>
            <mj-text font-size="28px" padding-left="0px" padding-right="0px" align="center"><b style="text-align:center;align:center;">Fresh &amp; Crispy</b></mj-text>
            <mj-text color="#737373" line-height="28px" font-size="18px" padding-left="0px" padding-right="15px" font-family="Arial, Helvetica, sans-serif" padding-bottom="0px">
               <p class="p1">
               </p>
               <p class="p1">Aromatic with vibrant fruits and innovative winemaking techniques, offering lifted aromas and a beautifully crafted profile.</p>
            </mj-text>
            <span style="color:#737373;font-size:18px;"><br/></span>
            <mj-text padding-right="0px" padding-left="15px" align="center" padding-top="0px"><b style="font-size:18.5px;color:#737373;">$59.00</b></mj-text>
            <mj-button background-color="#ffffff" color="#000000" border="3px solid #000000" width="100%" padding-right="15px" padding-left="15px" href="https://sharevino.co/partners/sharevino/wines/kalliston-assyrtiko" padding-top="15px"><span style="font-size:18px;">DISCOVER NOW</span></mj-button>
         </mj-column>
      </mj-section>
      <mj-section>
         <mj-column padding-right="0px" padding-left="0px" padding-bottom="0px" padding-top="10px">
            <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764469861068.png"></mj-image>
         </mj-column>
         <mj-column>
            <mj-text padding-top="0px" padding-bottom="0px" padding-left="0px" padding-right="0px" color="#786e6e" font-weight="500"><b id="ijxql-2" draggable="true" style="color:#0b9a18;font-size:18px;font-weight:900;">Reserve Your Spot</b></mj-text>
            <mj-text padding-right="0px" padding-left="0px" color="#54137c" padding-top="0px" padding-bottom="0px"><b style="font-size:25px;line-height:58px;">Unique Wine Experience</b></mj-text>
            <mj-text color="#737373" line-height="28px" padding-left="0px" font-size="18px" padding-right="0px" padding-bottom="15px">Secure your place at our upcoming tasting sessions and be among the first to explore new wines, meet producers, and enjoy exclusive experiences curated for WineLovers.</mj-text>
            <b style="color:#737373;">{Name}</b><span style="color:#737373;font-size:18px;"></span>
            <mj-button background-color="#ffffff" color="#000000" border="3px solid #000000" align="left" width="100%" padding-right="0px" padding-left="0px" padding-top="0px" href="https://sharevino.co/pricing"><span style="font-size:18px;">RESERVE A SPOT</span></mj-button>
         </mj-column>
      </mj-section>
      <mj-section padding-bottom="0px">
         <mj-column>
            <mj-text padding-left="0px" padding-right="0px" color="#786e6e" padding-bottom="0px" font-weight="700" font-size="17px">
               <span id="icj85-2" draggable="true" style="color:rgb(255, 133, 133);font-size:19px;"><b style="font-size:28px;color:rgb(99, 96, 96);font-weight:900;">What WineLovers Are Saying</b></span>
               <p></p>
            </mj-text>
         </mj-column>
      </mj-section>
      <mj-section padding-top="0px">
         <mj-column padding-top="10px" padding-bottom="0px" padding-left="0px" padding-right="10px">
            <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764243870769.jpg" padding-left="0px"></mj-image>
            <mj-text padding-bottom="0px" padding-right="0px" padding-left="0px" color="#b32929">
               <p class="p1"><span class="s1"></span></p>
               <h2><b style="color:#000000;"><span style="color:#b32929;">Taste</span>imonial About a Wine</b></h2>
               <p></p>
            </mj-text>
            <mj-text color="#737373" line-height="28px" font-size="18px" padding-left="0px" padding-right="0px"><span style="width:300px;"></span><span style="color:#737373;font-family:Arial, Helvetica, sans-serif;font-size:18px;">“Beautifully balanced with vibrant fruit and depth — one of my favorites from the tasting. Loved exploring the full profile and reading other WineLovers’ notes on ShareVino.”</span></mj-text>
            <mj-text font-size="18px" text-decoration="none" color="#a52834" padding-left="0px" padding-right="65px">
               <p class="p1"><span><span><span><b style="color:#000000;">— Marina G., WineLover</b></span></span></span></p>
            </mj-text>
         </mj-column>
         <mj-column padding-top="10px" padding-bottom="0px" padding-left="10px" padding-right="0px">
            <mj-image src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764243870769.jpg" padding-left="0px"></mj-image>
            <mj-text padding-bottom="0px" padding-right="0px" padding-left="0px">
               <p class="p1"><span class="s1"></span></p>
               <h2>
                  <p class="p1"><span class="s1"></span></p>
                  <p></p>
               </h2>
               <h2><b>Experience Testimonial</b></h2>
               <p></p>
            </mj-text>
            <mj-text color="#737373" line-height="28px" padding-left="0px" font-size="18px" padding-right="0px"><span style="width:300px;"></span><span style="color:#737373;font-family:Arial, Helvetica, sans-serif;font-size:18px;">“The event was fantastic — great energy, amazing producers, and I loved being able to save wines as I tasted them. ShareVino made the whole experience even more interactive.”</span></mj-text>
            <mj-text font-size="18px" text-decoration="none" color="#000000" padding-left="0px" padding-right="65px">
               <p class="p1"><span><span><span><b>— George Smith, Somm</b></span></span></span></p>
            </mj-text>
         </mj-column>
      </mj-section>
      <mj-section padding-bottom="0px" padding-top="0px">
         <mj-column>
            <mj-social font-size="12px" icon-size="24px" border-radius="12px" mode="horizontal">
               <mj-social-element name="web" background-color="#882121" href="www.sharevino.co"></mj-social-element>
               <mj-social-element name="instagram" color="#7c1c1c" background-color="#bd1313" href="https://www.instagram.com/share.vino/"></mj-social-element>
               <mj-social-element name="youtube" background-color="#761919" href="https://www.youtube.com/@sharevinonyc"></mj-social-element>
               <mj-social-element name="facebook" background-color="#8c1010" href="https://www.facebook.com/profile.php?id=100085763530440"></mj-social-element>
               <mj-social-element name="linkedin" background-color="#881414" href="https://www.linkedin.com/company/87235398/admin/dashboard/"></mj-social-element>
            </mj-social>
            <mj-divider border-width="1px"></mj-divider>
         </mj-column>
      </mj-section>
      <mj-section data-locked="1" padding-top="0px" padding-bottom="0px">
         <mj-column>
            <mj-text align="center" color="#786e6e" font-size="10px" font-family="Arial, Helvetica, sans-serif">
               You’re receiving this because you opted in to ShareVino updates.
               <a href="https://sharevino.co/account-settings">Unsubscribe</a>
               •
               <a href="https://sharevino.co/account-settings">Manage preferences</a>
            </mj-text>
         </mj-column>
      </mj-section>
   </mj-body>
</mjml>
`;

const LOCK_KEYS = ['removable', 'draggable', 'droppable', 'copyable', 'stylable', 'editable'];
const LOCK_PROPS = {
  removable: false,
  draggable: false,
  droppable: false,
  copyable: false,
  stylable: false,
  editable: false,
  selectable: false,
  toolbar: [], // hides delete/clone/move icons
};

const isLockedMarker = m => !!m?.getAttributes?.()?.['data-locked'];

function lockDeep(cmp) {
  // Propagate ensures children inherit changes too
  cmp.set({ ...LOCK_PROPS, propagate: LOCK_KEYS });
  // Also set directly on existing children (belt & suspenders)
  cmp.components().forEach(ch => lockDeep(ch));
}

const CampaignMessage = ({ valueMjml, onChangeMjml, onRendered, heightPx }) => {
  const editorRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    let editor;
    let cancelled = false;
    const load = async () => {
      if (editorRef.current || !heightPx) return;
      try {
        const grapesjs = (await import('grapesjs')).default;
        const pluginNewsletter = (await import('grapesjs-preset-newsletter')).default;
        const pluginMjml = (await import('grapesjs-mjml')).default;

        if (cancelled || !containerRef.current) return;
        const containerEl = containerRef.current;
        editor = grapesjs.init({
          container: containerRef.current,
          height: heightPx,
          fromElement: false,
          storageManager: false,
          plugins: [pluginNewsletter, pluginMjml],
          pluginsOpts: { pluginNewsletter: {}, pluginMjml: {} },
          assetManager: {
            upload: '/api/campaigns/email-assets/upload', // your endpoint that stores files and returns URLs
            uploadName: 'files',
            autoAdd: 1,
            // optional (older builds): prevent inline data URIs
            embedAsBase64: false,
          },
          // ⭐ Tell GrapesJS where to append the Spectrum color picker
          colorPicker: {
            appendTo: containerEl, // or wrapperRef.current if you have a wrapper Box
          },
        });
        if (cancelled) return;
        editorRef.current = editor;
        const initial = valueMjml || defaultNewsletterMjml;
        editor.setComponents(initial);
        // Ensure parent state has initial MJML/HTML even if user makes no edits
        try {
          const mjmlInit = editor.getMjml ? editor.getMjml() : editor.getHtml();
          onChangeMjml(mjmlInit);
          if (typeof onRendered === 'function') {
            const htmlInit = editor.getHtml ? editor.getHtml() : mjmlInit;
            onRendered(htmlInit);
          }
        } catch (err) {
          console.error(err);
        }
        // Normalize canvas background to white
        const style = document.createElement('style');
        style.innerHTML = `.gjs-cv-canvas { background-color: #ffffff !important; }`;
        document.head.appendChild(style);

        // 1) Lock the footer and all its nested components on load
        editor.on('load', () => {
          // showAvailableButtons(editor);
          // showBlocks(editor);
          removeBlock(editor, 'mj-raw');
          chnageHeroBlockContent(editor);
          changeWrapperBlockContent(editor);

          const footer = editor.getWrapper().find('#sv-unsub')[0];
          if (footer) lockDeep(footer);
          const IMPORT_CMD_IDS = [
            'gjs-open-import-template', // preset-newsletter / webpage
            'gjs-open-import', // generic import (some builds)
            'mjml-import', // grapesjs-mjml
            'open-layers',
            'canvas-clear',
            'export-template',
            'gjs-toggle-images',
            'open-layers',
          ];
          const panelId = 'options';
          // Remove by known IDs
          IMPORT_CMD_IDS.forEach(id => {
            try {
              editor.Panels.removeButton(panelId, id);
            } catch (_) {
              console.error(_);
            }
          });
          try {
            //editor.Panels.removeButton('views', 'open-layers');
            const el = editor.getContainer().querySelector('.gjs-pn-views .gjs-pn-buttons');
            if (el) el.style.justifyContent = 'end';
            const button = document.querySelector('.gjs-pn-btn[title="Open Layer Manager"]');
            if (button) button.style.display = 'none';
          } catch (_) {
            console.error(_);
          }
          // Safety pass: remove any button whose id/command contains "import"
          const panel = editor.Panels.getPanel(panelId);
          if (panel) {
            const btns = panel.get('buttons');
            btns &&
              btns.models.slice().forEach(btn => {
                const id = btn.id || btn.get?.('id');
                const cmd = btn.get?.('command');
                const looksImport = /import/i.test(String(id)) || (typeof cmd === 'string' && /import/i.test(cmd));
                if (looksImport) editor.Panels.removeButton(panelId, id);
              });
          }
        });

        /* TO DO remove after testing
				const wrapperEl = containerRef.current;

				editor.Panels.addButton('options', {
					id: 'sv-fullscreen',
					className: 'fa fa-expand',
					attributes: { title: 'Fullscreen' },
					command: ed => {
						// reset previous fullscreen state
						ed.stopCommand('core:fullscreen');
						// or 'fullscreen' if that’s the id in your version
						ed.runCommand('core:fullscreen', { target: "body" });
					},
				});*/

        // 2) If someone somehow adds/moves anything into the footer, lock it immediately
        editor.on('component:add', cmp => {
          if (cmp.closest(isLockedMarker)) lockDeep(cmp);
        });

        // 3) Block deletes (keyboard/cmd) for the footer or anything inside it
        editor.on('component:remove:before', (model, coll, opts = {}) => {
          if (isLockedMarker(model) || model.closest(isLockedMarker)) {
            opts.abort = true;
            editor.Modal?.alert('The unsubscribe footer is required in every email.');
          }
        });

        editor.on('update', () => {
          const mjml = editor.getMjml ? editor.getMjml() : editor.getHtml();
          onChangeMjml(mjml);
          if (typeof onRendered === 'function') {
            const html = editor.getHtml ? editor.getHtml() : mjml;
            onRendered(html);
          }
        });
      } catch (_) {
        console.error(_);
      }
    };
    load();
    return () => {
      cancelled = true;
      try {
        editorRef.current && editorRef.current.destroy();
      } catch (_) {
        console.error(_);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box sx={{ border: '1px solid #ccc', height: heightPx, overflow: 'hidden' }}>
      <Box ref={containerRef} sx={{ height: '100%' }} />
    </Box>
  );
};

CampaignMessage.propTypes = {
  campaignId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  valueMjml: PropTypes.string,
  onChangeMjml: PropTypes.func.isRequired,
  onRendered: PropTypes.func,
  heightPx: PropTypes.number,
};

export default CampaignMessage;
